export default {
  Fleet: {
    NotFound: 'Fleet not found',
    GliderRemoveTitle: 'Remove a glider from the fleet',
    ChooseGliderRemove: 'Choose a glider to remove from the fleet',
    FormationDirection: "Direcction of formation's center of gravity",
    ApplyToAll: 'Apply to all',
    Clear: 'Clear',
    AddToAll: 'Add to all',
    NoGliders: 'No glider mission associated',
    Coverage: 'Coverage area',
    Formation: 'Keep formation',
    Free: 'Free',
    Libelle: 'Label',
    Type: 'Type',
    NewTitle: 'New fleet',
    FormationTitle: 'Formation',
    FormationConfig: 'Glider distribution',
    DeadZoneConfig: 'Dead zone',
    CoverageConfig: 'Parameter',
    MainMissionPlan: 'Main mission plan',
    GliderAssociation: 'Glider association',
    StartFleet: 'Create fleet',
    OnlyOngoing: 'Show only ongoing missions',
    DzAlarm: 'Alarm deadzone (km)',
    DzCycle: 'Cycle deadzone (nb)',
    DzFormation: 'Formation deadzone (km)',
    DzTrackfollow: 'Track follow deadzone (km)',
    LoadFromTemplate: 'Load from smartplanning',
    Command: 'Mission command',
    Pause: 'Pause',
    Stop: 'Stop',
    Start: 'Start',
    Resume: 'Resume',
    Recalcul: 'Recalcul',
    Status: 'Mission status',
    Since: 'Since',
    Manager: 'Manager',
    Phone: 'Phone',
    ConfirmCommand: 'Do you really want to send the {command} command ?',
    ConfirmStopCommand:
      'do you really want to send the STOP command ? The fleet will be terminated and will no longer be operable.',
    DeleteDialogMessage: 'Do you really want to delete fleet {name} ?',
    ArgosRef: 'ARGOS reference',
    Check: {
      MissingSteps: 'Missing steps',
      MissingCurrentStep: 'Missing current step',
      MissingProfilNavOnStep: 'Missing navigation profile on a step',
      MissingProfilSciOnStep: 'Missing science profile on a step',
      MissingGliderAssociation: 'Missing glider association',
      MissingSmartTemplate: 'Missing smart template for grid coverage',
      MissingRecoveryPoint: 'Missing recovery point for common recovery',
      MissingResolutionTime: 'Resolution time must be betwe 1 and 120 minutes',
      InvalidDeadzoneAlarm: 'Alarm deadzone must be greater than formation deadzone',
    },
  },
  WobGbdType: {
    GliderInfoConnect: 'Glider InfoConnect',
    GliderMessage: 'Glider Message',
    GliderInfoCmd: 'Glider Info Command',
    GliderInfoDownload: 'Glider File Download',
    GliderInfofileNew: 'Glider New File',
    GliderInfofileMulti: 'Glider New File',
    GliderInfoHang: 'Glider InfoHang',
    NmeaSeaMrs: 'Nmea SeaMrs',
    NmeaSeaNav: 'Nmea SeaNav',
    NmeaSeaDst: 'Nmea SeaDst',
    NmeaSeaLog: 'Nmea SeaLog',
    NmeaSeaMul: 'Nmea SeaMul',
    NmeaSeaDrf: 'Nmea SeaDrf',
    NmeaSeaBtm: 'Nmea SeaBtm',
    NmeaSeaDev: 'Nmea SeaDev',
    NmeaSeaAlr: 'Nmea SeaAlr',
    NmeaSeaPrf: 'Nmea SeaPrf',
    NmeaSeaSrf: 'Nmea SeaSrf',
    NmeaSeaStp: 'Nmea SeaStp',
    NmeaSeaDrk: 'Nmea SeaDrk',
    NmeaSeaWpt: 'Nmea SeaWpt',
    NmeaPldOut: 'Nmea PldOut',
    NmeaSeaFlt: 'Nmea SeaFlt',
    NmeaSeaCom: 'Nmea SeaCom',
    NmeaSeaEnc: 'Nmea SeaEnc',
    NmeaSeaDrp: 'Nmea SeaDrp',
    GliderInfoTarget: 'Glider Info Target',
    GliderInfoModConf: 'Glider Info ModConf',
    GliderInfoModEvent: 'Glider Info ModEvent',
    Acknowledgement: 'Acknowledgement',
  },
  GliderInput: {
    Range: 'values',
    Excluded: 'excluded',
    default: 'default',
    ErrorStartCommand: "Error: command must start with '$' or '?'",
    ErrorValueCommand: "Error: command must have a value after an '=' sign",
    ErrorUnknownCommand: 'Inexisting command, do you still want to validate it?',
    ErrorRangeValue: 'Error: value not in range or excluded, do you still want to validate it?',
  },
  SimulationStatus: {
    DownloadingDatasets: 'downloading datasets models',
    DownloadingNetCdf: 'downloading netCDF models',
    Finished: 'finished',
    Error: 'error',
    Aborted: 'aborted',
    Failed: 'failed',
    Running: 'running',
  },
  CoverageStep: {
    GridGeneration: 'Grid generation',
    MatrixGeneration: 'Matrix generation',
    ProblemResolution: 'Problem resolution',
    FinalSimulation: 'Final simulation',
    Configuration: 'Configuration',
  },
  CoverageState: {
    Finished: 'finished',
    Aborted: 'aborted',
    Running: 'running',
  },
  App: {
    BackHome: 'Back to homepage',
    Logout: 'Logout',
    ChangePassword: 'Change my password',
    ShowLeftDrawerTooltip: 'Show left panel',
    HideLeftDrawerTooltip: 'Hide left panel',
    ShowRightDrawerTooltip: 'Show right panel',
    HideRightDrawerTooltip: 'Hide right panel',
    Close: 'Close',
    Debug: 'Go to debug',
    WebSocketTooltip: 'Websocket connection state',
    WebSocketOK: '(connected)',
    WebSocketKO: '(disconnected)',
    WebSocketWKO: '(reconnected - F5 recommended)',
    Notifications: 'Notifications',
    BellEnable: 'Enable sound notifications',
    BellAlert: 'Enable sound notifications on alert',
    BellDisable: 'Disable sound notifications',
    BellDisableSim: 'Disable sound notifications for simulation',
    ShowImage: 'Show image',
    CloseImage: 'Close image',
    GoToSite: 'Go to website',
  },
  ChangePassword: {
    Title: 'Change my password',
    OldPassword: 'Old Password',
    NewPassword: 'New Password',
    Modify: 'Send change',
    ChangePasswordProgress: 'Change password in progress',
    ChangePasswordSuccess: 'Change password success',
    ChangePasswordError: 'Change password error',
    Policy: 'Your password must comply with the following rules',
    PolicyLength: 'have at least {n} character | have at least {n} characters',
    PolicyNumber: 'have at least {n} digit|have at least {n} digits',
    PolicySpecial: 'have at least {n} special character|have at least {n} special characters',
    PolicyUpperCase: 'have at least {n} uppercase character|have at least {n} uppercase characters',
    PolicyLowerCase: 'have at least {n} lowercase character|have at least {n} lowercase characters',
    PolicyHistory:
      'You cannot reuse an old password|You cannot reuse your last password|You cannot reuse one of your {n} last passwords',
    PolicyPeriod: 'You must change your password every day|You must change your password at least every {n} days',
    Later: 'Change later',
    Expiration: 'Your password expires today,Your password expires tomorrow|Your password expires in {n} days',
  },
  Mounth: {
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
  },
  Global: {
    true: 'true',
    false: 'false',
    Ok: 'Ok',
    Cancel: 'Cancel',
    Save: 'Save',
    Close: 'Close',
  },
  Messages: {
    GliderConnect: 'The glider {gliKey} is back online',
    SimulationEnded: 'The simulation {simu} is {status}',
  },
  LangSwitcher: {
    Tooltip: 'Language',
  },
  CoordSelector: {
    Tooltip: 'Display of lat/lon',
  },
  Login: {
    Login: 'Login',
    Username: 'Username',
    Password: 'Password',
    LoginAction: 'Login',
    SendRequest: 'Send request',
    CancelRequest: 'Back to identification',
    AuthenticationProgress: 'Identification in progress',
    AuthenticationSuccess: 'Successful identification',
    AuthenticationError: 'incorrect identification',
    PassForgottenSuccess: 'Request sent successfully, an email has been sent to you.',
    PassForgottenProgress: 'Demand in progress',
    PassForgottenError: 'Error: Account and email do not match',
    ForgotPassword: 'Forgot your password',
  },
  CreatePassword: {
    Title: 'Password creation or recovery',
    Infos: 'In order to create a new password please fill in all the fields below.',
    NewPassword: 'New password',
    ConfirmNewPassword: 'New password confirmation',
    SendRequest: 'Send request',
    PasswordChanged: 'Password successfully changed',
    CreatePasswordProgress: 'Creating password...',
    CreatePasswordSuccess: 'Password created successfully',
    CreatePasswordError: 'Error creating password',
    PasswordAlreadyInUse: 'This password was already used, please choose another one.',
  },
  Home: {
    PilotTitle: 'Pilot',
    PilotSubTitle: 'Control your gliders',
    FleetTitle: 'Fleet Management',
    FleetSubTitle: 'View and control your fleets',
    ViewDataTitle: 'View Data',
    ViewDataSubTitle: 'View and analyze your data',
    MaintenaceTitle: 'Maintenance',
    MaintenaceSubTitle: 'Manage your gliders and sensors',
    TrainingTitle: 'Training',
    TrainingSubTitle: 'Discover our formations',
    MissionPlanning: 'Mission Planning',
    MissionPlanningSubTitle: 'Prepare your next missions',
    Configuration: 'Configuration',
    ConfigurationSubTitle: 'Manage your parameters',
    SmartPlanning: 'Smart Planning',
    SmartPlanningSubTitle: 'Plan and simulate your mission',
  },
  Color: {
    Default: 'Default',
    Black: 'Black',
    White: 'White',
    Yellow: 'Yellow',
    Orange: 'Orange',
    Red: 'Red',
    Purple: 'Purple',
    Blue: 'Blue',
    Green: 'Green',
  },
  Simulation: {
    NotFound: 'Scenario not found',
    Check: {
      Title: 'Simulation configuration',
      MissingStartDate: 'Missing start date',
      MissingSteps: 'Missing steps',
      MissingCurrentStep: 'Missing current step',
      MissingProfilNavOnStep: 'Missing navigation profile on a step',
      MissingProfilSciOnStep: 'Missing science profile on a step',
      FormationNeedAtLeastTwoGlider: 'Formation requires at least two gliders',
      FormationNeedOffsetForEachGlider: 'Formation requires an offset for each glider',
    },
    Distance: 'Distance between each glider (km)',
    DistanceHint: 'Distance in kilometer',
    EllipseRatio: 'Ellipse ratio',
    EllipseRatioHint: 'Number between 0 and 1',
    NbGlider: 'Glider number',
    GridParameter: 'Grid parameter',
    Rotation: 'Rotation',
    RotationHint: 'Rotation in degrees between 0 and 360',
    RotationEllipse: 'Ellipse rotation',
    NoCoverageIterationSelected: 'No coverage simulation selected',
    NoFormationIterationSelected: 'No keep formation simulation selected',
    NoPts: 'No points',
    AddGlobalPoint: 'Add a global point to the zone',
    AddPoint: 'Add points to the zone',
    Configuration: 'Configuration',
    Error: 'Error',
    DeleteDialogMessage: 'Do you really want to delete simulation {name} ?',
    DeleteMissionDialogMessage: 'Do you really want to delete mission {name} and all its simulations ?',
    NavigationMode: 'Navigation mode',
    Current: 'current',
    AddGlider: 'Custom glider',
    LoadGliderFromDb: 'Load from database',
    Abort: 'Abort simulation',
    BackToList: 'Back to list',
    ListTitle: 'Simulations',
    Add: 'Add new mission',
    NoSimulation: 'No simulation created',
    Libelle: 'Mission name',
    ReachSimulationPageTooltip: 'Display simulations results',
    AddSimulationTabTooltip: 'Open new simulation tab',
    ProcessingParameters: 'Processing parameters',
    SimConfig: 'Simulation configuration',
    MisConfig: 'Mission configuration',
    GliConfig: 'Glider configuration',
    MissionPlan: 'Mission planning',
    Run: 'Run simulation',
    RunCoverageGrid: 'Calculate coverage grid',
    ShowInfosPanelTooltip: 'Show simulation information panel',
    PlanMode: 'Plan mode',
    FilterStartMission: 'Mission from',
    FilterEndMission: 'Mission to',
    Simulator: 'Simulator',
    Manual: 'Manual',
    Coverage: 'Coverage area',
    KeepFormation: 'Keep formation',
    Formation: 'Formation',
    Circle: 'Circle',
    Comb: 'Comb',
    MainMissionPlan: 'Main mission plan',
    ExcludeArea: 'Exclude area',
    GridSize: 'Grid size (km)',
    GridSizedHint: 'Allowed value : [1;50]',
    DeploymentMode: 'Deployment mode',
    WptDeployment: 'Deployment waypoint',
    RecoveryMode: 'Recovery mode',
    WptRecovery: 'Recovery waypoint',
    Common: 'Common',
    Optimal: 'Optimal',
    RunPathCoverage: 'Run path coverage',
    NewTitle: 'New mission',
    Altimeter: 'Altimeter',
    Radio: 'Radio',
    Payload: 'Payload',
    BatteryType: 'Battery type',
    GliderType: 'Glider type',
    BmsTypes: 'Bms type',
    EnableScienceFiles: 'Enable science files',
    SurfacingTime: 'Surfacing time (s)',
    ResolutionTime: 'Resolution time (min)',
    ResolutionTimeHint: 'Allowed value : [1;120]',
    CurrentCorrection: 'Current correction',
    WaypointInit: 'Deployment point',
    SelectWaypointInit: 'Select deployment point from mission plan waypoint',
    SelectWaypointInitOnMap: 'Select deployment point on map',
    NbSimulation: 'Nb Simulations',
    ProcessingState: 'Processing state',
    ProcessingStep: 'Processing step',
    ProcessingTime: 'Processing time',
    EstimatedMissionEndDate: 'Estimated Mission end date',
    EstimatedEndDate: 'Estimated end in',
    MissionStartDate: 'Mission start date',
    Flasher: 'Flasher',
    ProcessingParameter: 'Processing parameters',
    EnergyStart: 'Energy on start (V)',
    EnergyEnd: 'Energy min allowed (%)',
    EnergyEndHint: 'Allowed value : [-1000;100]',
    StartDate: 'Start Date',
    EndDate: 'End Date',
    Result: 'Result',
    MissionDuration: 'Mission duration',
    CyclesNb: 'Number of cycles',
    EnergyAvailable: 'Energy available',
    Graph: {
      duration: 'Duration (days)',
      distance: 'Distance (km)',
      speed: 'Speed (km/h)',
      energy: 'Energy (%)',
      yos: 'Nb yos',
      gliders: 'Nb gliders',
    },
  },
  Pilot: {
    Images: {
      Single: 'Single',
      Concat: 'Concat',
      LoadingCycle: 'Loading picture for cycle ',
      LoadingAllCycle: 'Loading concat picture',
      DisabledForTenant: 'The Pictures module is not enabled for this company.',
    },
    BaseLayer: {
      Title: 'Basic Layer',
      Tooltip: 'Select basic layer',
      SourceInformation: 'Source information',
      OSM: {
        Title: 'Open Street Map',
        Info: 'Crédits : © OpenStreetMap contributors',
        UrlInfo: 'https://www.openstreetmap.org/copyright',
      },
    },
    Glider: {
      Title: 'Glider',
      Tooltip: 'Plotting option',
      ShowHeading: 'Show heading',
      ShowCurrents: 'Show mean currents',
      ShowAis: 'Show AIS activity',
      ShowCycle: 'Show cycle number',
      ShowTargetWaypoint: 'Show waypoint',
      ShowPath: 'Show path',
      ShowDrift: 'Show drift',
      ShowMissionPlan: 'Show mission plan',
      ShowMissionPlanValidation: 'Show Rval',
      ShowMissionLayer: 'Show mission layer',
      showEndMissionSimulation: 'Show estimated remaining navigation',
      DefaultGliderColor: 'default color',
    },
    Layer: {
      Title: 'Layer',
      Tooltip: 'Select layer',
      SourceInformation: 'Sources information',
      Config: {
        SelectElevation: 'Select an elevation',
        SelectStyle: 'Select a style',
        MinSpeed: 'Min [m/s]',
        MaxSpeed: 'Max [m/s]',
        Date: 'Date',
        MinTemp: 'Min [°C]',
        MaxTemp: 'Max [°C]',
        MinChl: 'Min [mg/m3]',
        MaxChl: 'Max [mg/m3]',
        MinLe: 'Min [le/m3]',
        MaxLe: 'Max [le/m3]',
        HeightMin: 'Min [m]',
        HeightMax: 'Max [m]',
        MinDepth: 'Min Depth [m]',
        MaxDepth: 'Max Depth [m]',
        SelectMounth: 'Select mounth',
        CurrentZoom: 'Zoom factor',
      },
    },
    Tools: {
      Title: 'Tools',
      Tooltip: 'Select a tool',
      ShowGraticule: 'Show meridian and parallel',
      MeasureDistance: 'Measure a distance',
      MeasureArea: 'Measure an area',
      MeasureCircle: 'Measure a circle',
      MeasureDepthProfile: 'Measure a bathymetric profile',
      Bearing: 'Bearing',
    },
    Info: {
      Title: 'Properties',
      Tooltip: 'Show glider information',
    },
    DepthProfile: {
      DialogResultTitle: 'Bathymetric profile',
      DataSource: 'Data source :',
    },
    MissionDrawer: {
      GeoHidden: 'Encrypted glider',
      EndMissionSimulation: 'Estimated remaining navigation',
      EndMissionSimulationNotApplicable: 'simulation not applicable',
      ShowEndMissionSimulation: 'Show estimated remaining navigation',
      HideEndMissionSimulation: 'Hide estimated remaining navigation',
      WholeFleet: 'Whole fleet',
      BackIn: 'Back in ',
      AutoGo: 'Auto GO',
      Loading: 'Loading data',
      ShowAllListedMissionTooltip: 'Show all missions',
      HideAllListedMissionTooltip: 'Hide all missions',
      AllMissions: 'All missions',
      AtSea: 'At sea',
      AtSeaTooltip: 'Show at sea missions',
      OnGoing: 'Ongoing',
      OnGoingTooltip: 'Show ongoing missions',
      Simulated: 'Simulated',
      SimulatedTooltip: 'Show ongoing simulated missions',
      Old: 'History',
      OldTooltip: 'Show history missions',
      MySelection: 'My Selection',
      MySelectionTooltip: 'Show your custom selection',
      FilterMissionTooltip: 'Filter your selection',
      ShowMissionTooltip: 'Show missions',
      HideMissionTooltip: 'Hide missions',
      ShowMoreMissionInfosTooltip: 'More information',
      HideMoreMissionInfosTooltip: 'Hide',
      SelectMissionTooltip: 'Zoom in on the map',
      SelectFleetTooltip: 'Zoom in on the map',
      SetAsTemplateRefTooltip: 'Define as reference template for mission',
      IsTemplateRefTooltip: 'Is the reference template for mission',
      MRS: 'MRS',
      Cycle: 'Cycle',
      Battery: 'Battery',
      UndewaterInfos: 'Glider under water',
      Date: 'Date',
      Time: 'Time',
      Latitude: 'Latitude',
      Longitude: 'Longitude',
      DivingLatitude: 'Diving latitude',
      DivingLongitude: 'Diving longitude',
      TargetLatitude: 'Target latitude',
      TargetLongitude: 'Target longitude',
      Nav: 'NAV',
      Heading: 'Heading',
      Speed: 'Speed',
      CurrentHeading: 'Current heading',
      CurrentSpeed: 'Current speed',
      Zb: 'Zb',
      Zt: 'Zt',
      Altitude: 'Altitude',
      PU: 'PU',
      PD: 'PD',
      BU: 'BU',
      BD: 'BD',
      Rate: 'Rate',
      Computed: 'COMPUTED',
      Distance: 'Distance',
      FlightTime: 'Flight Time',
      COG: 'COG',
      SOG: 'SOG',
      Drift: 'Drift',
      VspeedUp: 'Vertical speed during the ascent',
      VspeedDown: 'Vertical speed during the descent',
      MissionDuration: 'Mission Duration',
      SelectCustomMissionColorTooltip: 'Select a custom color',
      SelectCustomFleetColorTooltip: 'Select a custom color',
      ReachMissionPageTooltip: 'View data',
      PlayMissionTooltip: 'Play mission',
      ReplayMissionTooltip: 'Replay mission',
      GoToFirstYoTooltip: 'Go to first yo',
      GoToPreviousYoTooltip: 'Go to previous yo',
      GoToPreviousSurfacingYoTooltip: 'Go to previous surfacing',
      GoToNextYoTooltip: 'Go to next yo',
      GoToNextSurfacingYoTooltip: 'Go to next surfacing',
      GoToLastYoTooltip: 'Go to last yo',
      Days: 'Days',
      FilterGlider: 'Gliders',
      FilterEnseigne: 'Companies',
      FilterFleet: 'Fleets',
      FilterAlarm: 'Alarms',
      FilterOngoing: 'Ongoing missions',
      FilterSimule: 'Simulation missions',
      ShowInfosPanelTooltip: 'Show mission information panel',
      ShowFleetInfosPanelTooltip: 'Show fleet information panel',
      Consumption: 'Cons [W]',
      Duration: 'Duration',
      Formation: 'Formation',
      Depth: 'Zb [m]',
      BatteryLevel: 'Battery %',
      Sr: 'Sr',
      Vz: 'Vz',
      PhaseId: 'Phase Id',
      PhaseType: 'Phase Type',
      FleetViewMode: 'Select planification view mode',
      None: 'none',
      MoreNmea: 'Show more Nmea',
      MinusNmea: 'Show less Nmea',
    },
    MissionInfos: {
      CloseMissionTabTooltip: 'Close mission Tab',
      BackToMap: 'Back to map',
      AddMissionTabTooltip: 'Open new mission tab',
      GliderStatus: 'Glider Status',
      StartDate: 'Mission start date',
      EndDate: 'Mission end date',
      OnGoing: 'Ongoing',
      DistanceTraveled: 'Distance traveled',
      MissionDuration: 'Mission duration',
      LastConnect: 'Last Connection',
      LastCycle: 'Last Cycle',
      LastPosition: 'Last Position',
      BatteryLevel: 'Last Battery Level [V]',
      ShowMoreMissionInfosTooltip: 'More information',
      HideMoreMissionInfosTooltip: 'Hide',
      ExpandRightPanelTooltip: 'Expand right panel',
      EqualRightLeftPanelTooltip: 'Equalize panel sizes',
      ExpandLeftPanelTooltip: 'Expand left panel',
      DoubleClickToRename: 'Double click to rename tab',
      EscToCancel: "'Esc' to cancel",
      SaveTooltip: 'Save',
      CloseDetailTabTooltip: 'Close Tab',
      AddDetailTabTooltip: 'Add new tab',
      HideInfosPanelTooltip: 'Hide mission information panel',
      HideFleetInfosPanelTooltip: 'Hide fleet information panel',
    },
    FleetInfos: {
      FleetStatus: 'Status',
      StartDate: 'Start Date',
      EndDate: 'End Date',
      MissionDuration: 'Mission duration',
      LastConnect: 'Last connect',
      NbGlider: 'Nb Glider',
      BackToMap: 'Back to map',
    },
    MissionDetailMenu: {
      MissionDetailMap: 'Map',
      MissionDetailInformation: 'Information Panel',
      MissionDetailScienceGraphics: 'Custom science plot',
      MissionDetailScienceGraphicsList: 'Main science plots',
      MissionDetailNavigationGraphics: 'Custom navigation plot',
      MissionDetailNavigationGraphicsList: 'Main navigation plots',
      MissionDetailNmeaGraphicsList: 'Main nmea plots',
      MissionDetailAd2cp: 'Process RT ADCP',
      MissionDetailImage: 'Pictures',
      MissionDetailConsole: 'Command Console',
      MissionDetailFileTransfer: 'Files transfer',
      MissionDetailFileUpload: 'Files upload',
      MissionDetailNextSurfacingDo: 'Next surfacing do',
      MissionDetailSendMail: 'Mail alert',
      MissionDetailMapLayer: 'Mission layer',
      MissionDetailSingleWayPoint: 'Single Way Point',
      MissionDetailFtpRsync: 'Rsync / FTP',
      MissionDetailCoriolis: 'Coriolis',
      MissionDetailMissionPlan: 'Mission Planning',
      MissionDetailLogBook: 'Logbook',
      MissionDetailFleetManagement: 'Fleet Management',
      MissionDetailAnticollision: 'Anticollision',
      MissionDetailEncryption: 'Encryption',
      MissionDetailQuickControl: 'Quick Control',
      SimulationDetailScienceGraphics: 'Custom science plot',
      SimulationDetailScienceGraphicsList: 'Main science plots',
      SimulationDetailMap: 'Map',
      SimulationDetailMapLayer: 'Mission layer',
      SimulationDetailParameter: 'Simulation Parameters',
      CoverageDetailParameter: 'Coverage parameters',
      FormationDetailParameter: 'Keep formation',
      SimulationDetailMissionPlan: 'Mission Planning',
      SimulationDetailFileTransfert: 'Files transfer',
      SimulationDetailCompareSimulations: 'Compare Simulations',
      SimulationDetailSinglePlotsList: 'Single simulation plots',
      MissionEndSimulationSinglePlots: 'Single simulation plots',
      MissionEndSimulationSinglePlotsList: 'Single simulation plots',
    },
    FleetDetailMenu: {
      FleetDetailMap: 'Map',
      FleetDetailConsole: 'Fleet command console',
      FleetDetailMissionPlan: 'Fleet mission planning',
      FleetDetailLogBook: 'Fleet logbook',
      FleetDetailNextSurfacingDo: 'Fleet next surfacing do',
      FleetDetailSendMail: 'Fleet alert',
      FleetDetailScienceGraphics: 'Fleet custom science plot',
      FleetDetailNavigationGraphics: 'Fleet custom navigation plot',
      FleetDetailImage: 'Fleet pictures',
      FleetDetailSmartControl: 'Mission Informations',
      FleetDetailParameter: 'Fleet parameters',
      FleetDetailParameterFormation: 'Formation parameters',
      FleetDetailParameterCoverage: 'Coverage parameters',
      FleetDetailFileTransfer: 'Fleet file transfer',
      FleetDetailFtpRsync: 'Fleet Rsync / FTP',
      FleetDetailScienceGraphicsList: 'Fleet science plots',
      FleetDetailNavigationGraphicsList: 'Fleet navigation plots',
    },
    Graphics: {
      LoadingData: 'Loading data',
      FailDownloadData: 'Failed to load data',
      TryReload: 'Try reload data',
      None: 'None',
      ZoomBoth: 'Zoom',
      ZoomXAxis: 'Zoom X axis',
      ZoomYAxis: 'Zoom Y axis',
      Date: 'Date',
      Temperature: 'Temperature',
      Pressure: 'Pressure',
      Depth: 'Depth',
      Conductivity: 'Conductivity',
      DOF: 'DOF',
      Heading: 'Heading',
      Pitch: 'Pitch',
      Roll: 'Roll',
      Ballast: 'Ballast',
      Lin: 'Linear',
      Ang: 'Angular',
      Voltage: 'Voltage',
      ErrorSelectedCycle: 'the selected cycle is not available',
      XAxisVariableTooltip: 'Select X axis',
      YAxisVariableTooltip: 'Select Y axis',
      ColorAxisVariableTooltip: 'Select Z axis',
      ZoomBehaviourTooltip: 'Zoom type',
      PointSizeTooltip: 'Points size',
      VoronoiCellRender: 'Interpolation',
      SaveConfigTooltip: 'Save graph configuration',
      LoadConfigTooltip: 'Load graph configuration',
      Cycle: 'Cycle',
      ResetGraphTooltip: 'Reset',
      ConfigAxisTooltip: 'Edit axis properties',
      NoDataAvailable: 'No data available',
      LastDataModeTooltip: 'Select time limit',
      LimitDataALL: 'All Data',
      LimitDataLAST_12H: 'Last 12 hours',
      LimitDataLAST_24H: 'Last 24 hours',
      ConfigName: 'Configuration name',
    },
    ChartConfig: {
      Title: 'Axis configuration',
      XAxis: 'X axis',
      YAxis: 'Y axis',
      ColorAxis: 'Z axis',
      MinValue: 'Min value',
      MaxValue: 'Max value',
      MinColor: 'Min Color',
      MidColor: 'Med Color',
      MaxColor: 'Max Color',
      SelectColorBarTooltip: 'Choose color bar',
      PredefinedBar: 'Predefined color bar',
      Default: 'Default',
      Restore: 'Restore',
      Valid: 'Valid',
    },
    MissionSearch: {
      MissionName: 'Mission',
      LastConnect: 'Last connect',
    },
    MissionConsole: {
      LoadMoreData: 'Load more data',
      LoadAllData: 'Load all data',
      Date: 'Date',
      Time: 'Time',
      FromTo: 'From/To',
      Cycle: 'Cycle',
      Message: 'Message',
      Send: 'Send',
      Clear: 'Clear console',
      Command: 'Command',
      DownloadAllConsoleLog: 'Download all log',
      ModConfFilter: 'ModConf',
      ShowAll: 'Show all',
      HideAll: 'Hide all',
      GdbFilter: 'Filter rows',
      AutoScroll: 'Auto Scroll enabled',
      AutoScrollDisabled: 'Auto Scroll disabled',
    },
    MapLayer: {
      LinkExistingLayer: 'Link existing layer',
      ExistingLayers: 'Select a layer to link',
      NewCustomLayer: 'New custom layer',
      CustomLayer: 'Custom mission layers',
      AddNewCustomLayer: 'Add new custom layer',
      DeleteCustomLayerDialogMessage: 'Do you really want to Delete this layer?',
    },
    LogBook: {
      Date: 'Date',
      Time: 'Time',
      From: 'From',
      Cycle: 'Cycle',
      Message: 'Message',
      Send: 'Send',
      EditMessage: 'Edit',
      Cancel: 'Cancel',
      Download: 'Download',
      Modified: 'modified',
      AlertMission: 'Pilot alerts',
    },
    NextSurfacing: {
      Configuration: 'Configuration',
      EnableNsd: 'Enable',
      NextSurfacing: 'Next surfacing',
      Command: 'Command',
      AllSurfacing: 'All Surfacing',
      EnableAll: 'All Connect',
      NextConnect: 'Next connection',
      RestoreConfig: 'Restore',
      ValidateConfig: 'Save',
      NoDataAvailable: 'No data available',
    },
    MissionPlan: {
      Configuration: 'Configuration',
      EnableMissionPlan: 'Enable',
      StagingMissionPlan: 'Staging mission plan',
      EditStagingMissionPlan: 'Edit mission plan',
      RestoreConfig: 'Restore',
      ValidateConfig: 'Save',
      CancelEditStaging: 'Cancel',
      ValidEditStaging: 'Save Draft mission plan',
      PublishStagingToIris: 'Save',
      SaveAsTemaplate: 'template',
      SaveAsTemplateTitle: 'Save current mission plan as smart planning template',
      TemplateName: 'Template name',
      SaveAsTemaplateTooltip: 'save as template',
      ConfirSaveAsTemplate: 'Confirm creation template :',
      MissionPLanSteps: 'Mission Plan steps',
      CreateNewMissionPlan: 'Create New Mission Plan',
      CreateFromTemplate: 'Create from template',
      NoDataAvailable: 'No data available',
      LoadFromTemplate: 'Replace with template',
      ReloadFromIris: 'Restore',
      CurrentCorrection: 'Current correction',
      EnableCorrected: 'Enable',
      Payload: 'Payload',
      EnablePayload: 'Enable',
      Heading: 'Heading',
      Waypoint: 'Waypoint',
      Trackfollowing: 'Track following',
      Lookahead: 'Lookahead (km)',
      CreateEmptyMissionPlan: 'Create empty mission plan',
      AlertCurStepTitle: 'No current step selected',
      AlertCurStep: 'Do you want to leave anyway ?',
      AlertSaveCurStep: 'Do you want to save anyway ?',
      TemplateExistBadTypeAlert:
        'One smart planning alread exist with this template name and is not of type Manual. Please choose another name.',
      TemplateExistAlert:
        'One smart planning with this name already exists. Do you want to overwrite his mission plan and set it as reference ?',
    },
    FtpRsync: {
      ConfigurationFtp: 'Configuration Ftp',
      ConfigurationRsync: 'Configuration Rsync',
      EnableFtp: 'Enable',
      EnableRsync: 'Enable',
      Server: 'Server',
      Port: 'Port',
      Login: 'Login',
      Password: 'Password',
      Tls: 'Tls',
      Sftp: 'Sftp',
      SyncPaths: 'SyncPaths',
      'B-ArchTooltip': 'Contains the subsampled data files of the compressed glider in gz format',
      'C-CsvTooltip': 'Contains the subsampled data files of the glider in csv format',
      'D-CatTooltip': 'Contains the concatenated files of all yos of a mission (gli.sub.all and pld1.sub.all)',
      'E-ImgTooltip': 'Contains images',
      'F-GeoTooltip': 'Contains geographical information about the glider in KML format',
      'G-LogsTooltip': 'Contains log files',
      'H-MiscTooltip': 'Contains miscellaneous files',
      'J-NetCDFTooltip': 'Contains the subsampled data files of the glider in NetCDF format',
      DstPaths: 'DstPaths',
      Export: 'Export',
      PrivateKey: 'PrivateKey',
      RestoreConfig: 'Restore',
      ValidateConfig: 'Save',
    },
    SendMail: {
      Configuration: 'Configuration',
      EnableSendMail: 'Enable',
      GliderAlarm: 'Mail on glider alarm',
      IrisAlarm: 'Mail on iris alarm',
      SurfacingAlarm: 'Mail on surfacing',
      DetectionAlarm: 'Mail on detection',
      RestoreConfig: 'Restore',
      ValidateConfig: 'Save',
      DeleteMailDialogMessage: 'confirm before deleting mail',
    },
    Ad2cp: {
      Configuration: 'Configuration',
      EnableAd2cp: 'Enable',
      Settings: 'Settings',
      CsName: 'CS',
      BdName: 'BD',
      PositionName: 'Position',
      CellsTransmitedName: 'Cells transmitted',
      QualityControl: 'Quality control',
      Resolution: 'Resolution [m]',
      MaxRelSpeed: 'Max. relative speed [m.s-1]',
      MaxShearSurface: 'Max. shear in surface [s-1]',
      MaxShearDepth: 'Max. shear in depth [s-1]',
      MaxDeviation: 'Max. deviation from optimal angle [°]',
      MinNbData: 'Min. number of data for shear [-]',
      MaxMissingDepth: 'Max. missing depth [%]',
      MaxMissingTime: 'Max. missing time [%]',
      Reporting: 'Reporting',
      LastTimeProcess: 'Last time process',
      CurrentState: 'Current state',
      DataIntegration: 'Data integration',
      DtiReady: 'Ready',
      DtiRequested: 'Requesting data',
      DtiUpdateLocalData: 'Updating local data',
      DtiWaiting: 'Waiting for data',
      DtiStaging: 'Staging',
      DtiIndexing: 'Indexing',
      ResetConfig: 'Reset default parameters',
      Run: 'Run',
      RestoreConfig: 'Restore',
      ValidateConfig: 'Save',
      Bottom: 'Bottom',
      Top: 'Top',
      NoDataAvailable: 'No data available',
    },
    FileTransfert: {
      Configuration: 'Configuration',
      EnableDownload: 'Enable download',
      LastMissingTitle: 'Catch Up',
      EnableCatchUp: 'Enable Catch Up',
      LastFileTitle: 'Download last files',
      NavFieldName: 'NAV',
      PldFieldName: 'PLD',
      MultiYoPolicy: 'Multi-yo policy',
      FirstFile: 'First file',
      LastFile: 'Last file',
      OptionNone: 'None',
      OptionAll: 'All',
      FileList: 'File list',
      SpecificFileTitle: 'Download specific files',
      ResetConfig: 'Default',
      RestoreConfig: 'Restore',
      ValidateConfig: 'Save',
      DownloadStatus: 'Download Status',
      FileRequestedNextSurfacing: 'File requested at next surfacing',
      Cycle: 'Cycle',
      AddToRequested: 'Add to requested file list',
      NoRequestedFile: 'No file to download',
      NoDataAvailable: 'No data available',
      NotActivated: 'Science file not activated for simulation',
      TooMuchFile: 'You can select up to 10 files',
    },
    FileUpload: {
      Title: 'Uploading mission files',
      AddFiles: 'Add files to the list',
      ClearAll: 'Clear not uploading files',
      DeleteError: 'Remove invalid files',
      RetryAll: 'Retry all',
      UploadAll: 'Upload all',
      Name: 'Name',
      NotCurrentMission: 'File not belonging to the current mission',
      UploadTooltip: 'Upload file to server',
      RemoveTooltip: 'Delete from the list',
      AnalyseFile: 'Analysis of files',
    },
    SingleWayPoint: {
      Configuration: 'Configuration',
      EnableSingleWayPoint: 'Enable single way point',
      SingleWayPoint: 'SingleWayPoint',
      HeadingDeadZone: 'Heading dead zone',
      LatTarget: 'Target latitude',
      LonTarget: 'Target longitude',
      NoDataAvailable: 'No data available',
      RestoreConfig: 'Restore',
      ValidateConfig: 'Save',
      SetTargetHere: 'Set target here',
    },
    Coriolis: {
      Configuration: 'Configuration',
      Enable: 'Enable',
      RestoreConfig: 'Restore',
      ValidateConfig: 'Save',
      DataSync: 'Data Synchronization',
      AutoExport: 'Enable automatic export (at glider hang)',
      InfosDownload: 'Click to download templates and documentation',
      UploadTitle: 'Uploading JSON files',
      Run: 'Manual run',
      LastExport: 'Last export',
    },
    Encryption: {
      Configuration: 'Encryption Configuration',
      Passphrase: 'Passphrase',
      Reveal: 'Reveal',
      Save: 'Save',
      NoPassphraseDefined: 'No passphrase defined',
      SaveSuccess: 'Passphrase saved',
      SaveError: 'Error saving passphrase',
    },
    Anticollision: {
      Configuration: 'Anticollision Configuration',
      Enable: 'Enable',
      NoDataAvailable: 'No data available',
      ValidateConfig: 'Save',
      RestoreConfig: 'Restore',
      MonitoringRadius: 'Monitoring radius (km)',
      MonitoringRadiusValue: 'Monitoring radius ({0} km)',
      EmergencyRadius: 'Emergency radius (km)',
      EmergencyRadiusValue: 'Emergency radius ({0} km)',
      EmergencyBottomDepth: 'Emergency bottom depth (m)',
      EmergencyTopDepth: 'Emergency top depth (m)',
      PeriodProjection: 'Projection period (min)',
      PeriodProjectionValue: 'Projection period ({0} min)',
      DurationProjection: 'Projection duration (min)',
      DurationProjectionValue: 'Projection duration ({0} min)',
      RuleMin: 'Min {0} {1}',
      RuleMax: 'Max {0} {1}',
      RuleMonitoringGreater: 'Must be > emergency radius',
      RuleEmergencyLess: 'Must be < monitoring radius',
      RuleZbGreaterZt: 'Must be > top depth',
      RuleZtLessZb: 'Must be < bottom depth',
      SaveErrorTitle: 'Invalid form',
      SaveErrorIntro: 'Some fields are invalid:',
      StatusNoRisk: 'Anticollision - No detected danger',
      StatusRisk: 'Anticollision - Immediate danger',
      StatusNoData: 'Anticollision - AIS data unavailable',
    },
    QuickControl: {
      DisabledForTenant: 'The Quick Control module is not enabled for this company.',
      MissionDetailMenu: {
        MissionDetailQuickControl: 'Quick Control',
      },
      StateBar: {
        AtSurface: 'At surface - Ready to deploy',
        ReadyToDive: 'Ready to dive',
        InspectionNeeded: 'Inspection needed',
        WaitingCommands: 'Waiting for commands',
      },
      Actions: {
        Title: 'Quick actions',
        Dive: 'Dive order',
        Surface: 'Stay at surface',
        AckAlarm: 'Acknowledge alarm',
        Download: 'Download data',
        Flasher: 'Flasher',
        Radio: 'Radio',
        Payload: 'Payload',
        MissionPlan: 'Activate Mission Planning',
      },
      EasyWaypoint: {
        Title: 'Easy Waypoint',
        NavMode: 'Navigation mode',
        WithNavProfile: 'With navigation profile',
        Lat: 'Latitude',
        Lon: 'Longitude',
        Validate: 'Save',
        Restore: 'Restore',
        Cancel: 'Cancel',
        SetTargetHere: 'Set target here',
      },
      NavProfile: {
        Title: 'Navigation profile',
        Save: 'Save profile',
        Cancel: 'Cancel',
        NavigationProfil: 'Navigation profile',
        Label: 'label',
        Bd: 'Descent',
        BdTooltip: 'Ballast value applied on the way down',
        Bu: 'Ascent',
        BuTooltip: 'Ballast value applied on the way up',
        UnitLabel: 'Unit',
        UnitVolume: 'Volume (mL)',
        UnitVz: 'Vertical speed (cm/s)',
        UnitVx: 'Horizontal speed (cm/s)',
        UnitLinear: 'Linear position (mm)',
        UnitDegrees: 'Degrees (°)',
        Pd: 'Descent',
        PdTooltip: 'Pitch value applied on the way down',
        Pu: 'Ascent',
        PuTooltip: 'Pitch value applied on the way up',
        Sr: 'Surfacing rate',
        SrTooltip: 'The frequency of surfacing in number of yo',
        Zb: 'Bottom Depth (m)',
        ZbTooltip: 'Bottom rollover value in m',
        Zt: 'Top Depth (m)',
        ZtTooltip: 'Top rollover value in m',
        Zs: 'Surfacing Depth (m)',
        ZsTooltip: 'Immersion value for generating a surface in m',
        Alt: 'Altitude (m)',
        AltTooltip: 'Minimum altitude value to cause a rollover',
      },
      Tables: {
        Pending: 'Pending commands',
        Accepted: 'Accepted commands',
        Refused: 'Refused commands',
        ColCommand: 'Command',
        ColDate: 'Date',
        ColStatus: 'Status',
        StatusPending: 'Pending',
        StatusAccepted: 'Accepted',
        StatusRefused: 'Refused',
        AllSurfacingTooltip: 'NSD command executed on every surfacing (allSurfacing)',
        NextSurfacingTooltip: 'NSD command scheduled for next surfacing (read-only)',
      },
      Nsd: {
        AutoEnableTitle: 'NSD auto-activation',
        ModuleEnabled: 'The NSD module has been enabled.',
      },
      Errors: {
        Timeout: 'Glider unreachable — please retry',
        ConnectionRefused: 'IRIS server unavailable',
        SocketError: 'IRIS network error',
        NoBody: 'No data available',
        Generic: 'Error communicating with IRIS',
      },
    },
    Nmea: {
      NoDataAvailable: 'No data available',
    },
  },
  CodeAlarm: {
    LowVoltage: 'Low battery',
    MissionOverTime: 'Underwater timeout alarm',
    OverDepth: 'Over depth',
    WaterInlet: 'Water inlet',
    Vacuum: 'Internal pressure exceeded',
    Stability: 'Bad glider stability',
    Ballast: 'ballast volume over the specified range',
    LinearController: 'Linear displacement over the specified range',
    AngularController: 'Angular displacement over the specified range',
    Communication: 'Communication gap',
    InconsistentPitchAngle: 'Inconsistent Pitch Angle',
    InconsistentDepth: 'Inconsistent vertical displacement',
    DepthSensor: 'No data received from the depth sensor',
    PayloadProblem: 'Payload malfunction',
    StateOverTime: 'The time allowed for a given state has been reached',
    ReleaseDevice: 'Release device triggered',
    Write: 'Problem with writting data',
    PayloadTrigger: 'Signal triggered by the accoustic payload',
    SdCard: 'SD card not found',
    GliderReboot: 'Glider Reboot',
  },
  GliderWaitingMode: {
    Disconnected: 'Disconnected',
    WaitingForGo: 'Waiting for Go',
    WaitingForResume: 'Waiting for Resume',
    WaitingForAck: 'Waiting for acknowledgement',
    null: '',
  },
  Configuration: {
    MapLayers: 'Map Layers',
  },
  Admin: {
    Menu: 'Menu',
    UnsaveDialogMessage: 'Do you really want to leave?<br/>You have unsaved changes!',
    DeleteDialogMessage: 'Do you really want to Delete this item?',
    Warning: 'Warning',
    Error: 'Error',
    Cancel: 'Cancel',
    Save: 'Save',
    Remove: 'Delete',
    Search: 'Search...',
    FilterTooltip: 'Filter',
    ResetFilterTooltip: 'Reset filter',
    SaveItem: 'Saving {item}',
    SaveOk: "Object '{item}' saved successfully",
    ErrorSave: 'Error while saving : {error}',
    ErrorOnSave: 'Error while saving',
    LaunchSimulation: 'Launching simulation {item}',
    ErrorCoverageGrid: 'Error during coverage grid calculation : {error}',
    ErrorOnCoverageGrid: 'Error during coverage grid calculation',
    ErrorCoverageSimulation: 'Error during coverage simulation : {error}',
    ErrorOnCoverageSimulation: 'Error during coverage simulation',
    ErrorFormationSimulation: 'Error during keep formation simulation : {error}',
    ErrorOnFormationSimulation: 'Error during keep formation simulation : {error}',
    ErrorSimulation: 'Error during simulation launch : {error}',
    ErrorOnSimulation: 'Error during simulation launch',
    ErrorStopSimulation: 'Error during simulation stop : {error}',
    ErrorOnStopSimulation: 'Error during simulation stop',
    DeleteItem: "Deleting '{item}'",
    DeleteItemOk: "Deleting '{item} successfully'",
    DeleteOk: "Object '{item}' deleted successfully",
    ErrorDelete: 'Error while deleteing : {error}',
    ErrorOnDelete: 'Error while deleteing',
    PasswordSaveOk: 'Password modify successfully',
    PasswordErrorSave: 'Error during password modification : {error}',
    PasswordErrorOnSave: 'Error during password modification',
    Loading: "Loading '{item}'",
    LoadingOk: "Loading '{item}' successfulley",
    LoadingError: "Error loading '{item}'",
    Glider: {
      Title: 'Glider',
      MenuTitle: 'Manage Glider',
      List: {
        NbGlider: 'No glider | {n} glider | {n} gliders',
        AddTooltip: 'Add a glider',
        ReachGliderTooltip: 'Edit this glider',
        FilterOwner: 'Owner',
      },
      Form: {
        Modify: 'Modify Glider',
        New: 'New Glider',
        Key: 'Name',
        Surname: 'Surname',
        Alias: 'Alias',
        Model: 'Model',
        Owner: 'Owner',
        ManufacturingDate: 'Manufacturing Date',
        SerialNumber: 'Serial Number',
        Manufacturer: 'Manufacturer',
        MaxDepth: 'Max Depth (dbar)',
        Status: 'Status',
        GliderComposition: 'Glider Composition',
      },
    },
    AisQuery: {
      MenuTitle: 'AIS query count',
    },
    Enseigne: {
      Title: 'Company',
      MenuTitle: 'Manage Company',
      List: {
        NbEnseigne: 'No company | {n} company | {n} companies',
        AddTooltip: 'Add a company',
        ReachEnseigneTooltip: 'Edit this company',
      },
      Form: {
        Modify: 'Edit company',
        New: 'New company',
        Key: 'Name',
        Surname: 'Surname',
        AdcpOn: 'Enable AD2CP module',
        AisOn: 'Enable AIS module',
        AisAnticollisionOn: 'Enable AIS anticollision module',
        PostprocessImageOn: 'Enable Postprocess image module',
        QuickControlOn: 'Enable Quick Control module',
        FleetOn: 'Enable fleet management',
        SmartPlanningOn: 'Enable Smart Planning',
        CoverageOn: 'Enable coverage',
        FormationOn: 'Enable formation',
      },
    },
    UmbClasse: {
      Title: 'Mobil Unit Class',
      MenuTitle: 'Manage Mobil Unit Class',
      List: {
        NbUmbClasse: 'No unit mobil class | {n} unit mobil class | {n} units mobil class',
        AddTooltip: 'Add an unit mobil class',
        ReachUmbClasseTooltip: 'Edit Unit Mobil Class',
      },
      Form: {
        Modify: 'Modify Unit Mobil Class',
        New: 'New Unit Mobil Class',
        Key: 'Name',
        Surname: 'Surname',
      },
    },
    UmbType: {
      Title: 'Mobil Unit Type',
      MenuTitle: 'Manage Mobil Unit Type',
      List: {
        NbUmbType: 'No unit mobil type | {n} unit mobil type | {n} units mobil type',
        AddTooltip: 'Add an unit mobil type',
        ReachUmbTypeTooltip: 'Edit Unit Mobil Type',
      },
      Form: {
        Modify: 'Modify Unit Mobil Type',
        New: 'New Unit Mobil Type',
        Key: 'Name',
        Surname: 'Surname',
        MaxPressure: 'Max pressure',
        ConsoMoy: 'Mid Conso',
        Maker: 'Maker',
        Integrator: 'Integrator',
        UmbClasse: 'Classe',
      },
    },
    Role: {
      Title: 'Role',
      MenuTitle: 'Manage Role',
      List: {
        NbRole: 'No role | {n} role | {n} roles',
        AddTooltip: 'Add a role',
        ReachRoleTooltip: 'Edit role',
      },
      Form: {
        Modify: 'Modify role',
        New: 'New role',
        Surname: 'Role name',
        Key: 'Role key',
      },
    },
    UniteMobile: {
      Title: 'Mobil Unit',
      MenuTitle: 'Manage Mobil Unit',
      List: {
        NbUniteMobile: 'No unit mobil | {n} unit type | {n} units mobil',
        AddTooltip: 'Add an unit mobil',
        ReachUniteMobileTooltip: 'Edit Unit Mobil',
      },
      Form: {
        Modify: 'Modify Unit Mobil',
        New: 'New Unit Mobil',
        Key: 'Name',
        Surname: 'Surname',
      },
    },
    User: {
      Title: 'User',
      MenuTitle: 'Manage User',
      List: {
        NbUser: 'No user | {n} user | {n} users',
        AddTooltip: 'Add an user',
        ReachUserTooltip: 'Edit user',
        FilterCompany: 'Company',
        FilterRole: 'Role',
      },
      Menu: {
        FicheUser: 'User recap',
        Infos: 'General information',
        Role: 'Resources management',
        Password: 'Password',
      },
      Form: {
        Modify: 'Modify User',
        New: 'New User',
        Civility: 'Civility',
        Password: 'Password',
        Name: 'Name',
        Surname: 'Surname',
        Company: 'Company',
        Login: 'Login',
        Email: 'Email',
        Phone: 'Phone',
        InternalNote: 'Internal note',
        Photo: 'Photo',
      },
      Rights: {
        RoleToAdd: 'Role to add',
        GliderToSelect: 'Target glider',
        AddRole: 'Add role',
        GliRole: 'Specific glider role',
        MisRole: 'Specific mission role',
        MissionToSelect: 'Target mission',
        NoSpecificGliderRole: 'No specific glider role',
        NoSpecificMissionRole: 'No specific mission role',
      },
      Password: {
        OldPassword: 'Actual password',
        Password: 'New password',
        ConfirmPassword: 'Confirm new password',
      },
    },
    MesureType: {
      Title: 'Measure Type',
      MenuTitle: 'Manage Measure Type',
      List: {
        NbMesureType: 'No measure type | {n} measure type | {n} measure types',
        AddTooltip: 'Add an measure type',
        ReachMesureTypeTooltip: 'Edit Measure Type',
        FilterUmbType: 'Mobil Unit Type',
        FilterMesureUnit: 'Mesure Unit',
      },
      Form: {
        Modify: 'Modify Measure Type',
        New: 'New Measure Type',
        Key: 'Variable Name',
        Libelle: 'Libelle',
        Unit: 'Unit',
        UmbType: 'Mobil Unit Type',
        RegEx: 'Reguar Expression',
        IsCalc: 'Calculated measure',
        Offset: 'Power-of-10 factor',
        DefaultOffset: 'Default behaviour',
        OffsetInfos:
          'Power-of-10 factor (positive or negative) to be applied to the measurements from this sensor to get a value whose integer part fits within a maximum of 8 digits (this parameter is required only for data storage but does not affect neither graphs nor displayed values).',
        ConfigGraphDisplay: 'Configuration graph display',
        AutoPlot: 'Show on main science plots',
        InvertedYAxis: 'Is Y axis Inverted',
        LogarithmeAxis: 'Is axis in log scale',
        ForceDomain: 'Force domain scale',
        MinDomain: 'Min domain value',
        MaxDomain: 'Max domain value',
        Color: 'Color for profile',
        ResetConfigGraphDisplay: 'Reset configuration graph display',
      },
    },
    MesureUnite: {
      Title: 'Measure Unit',
      MenuTitle: 'Manage Measure Unit',
      List: {
        NbMesureUnite: 'No measure unit | {n} measure unit | {n} measures unit',
        AddTooltip: 'Add an measure unit',
        ReachMesureUniteTooltip: 'Edit Measure Unit',
      },
      Form: {
        Modify: 'Modify Measure Unit',
        New: 'New Measure Unit',
        Libelle: 'Libelle',
        Symbol: 'Symbol',
      },
    },
    Simulation: {
      Title: 'Simulation',
    },
    AdminMission: {
      Title: 'Mission',
      MenuTitle: 'Manage Mission',
      List: {
        NbAdminMission: 'No mission | {n} mission | {n} missions',
        AddTooltip: 'Add a mission',
        ReachAdminMissionTooltip: 'Edit this mission',
        FilterOngoing: 'Ongoing missions',
        FilterSimule: 'Simulation missions',
        FilterOwner: 'Company',
        FilterGlider: 'Glider',
      },
      Form: {
        Modify: 'Edit mission',
        New: 'New mission',
        Libelle: 'Alias',
        Glider: 'Glider',
        Ongoing: 'Ongoing',
        Note: 'Note',
        Index: 'Numero',
        UpdateMeasureTypeAssociation: 'Update measure type association',
        MisActif: 'Mission ongoing',
        SysAdminOnly: 'System adminstrator only',
      },
      Rights: {
        RoleToAdd: 'Role to add',
        AddRole: 'Add role',
        UserRole: 'Specific user role',
        UserToSelect: 'Target user',
        NoSpecificUserRole: 'No specific user role',
      },
    },
    AdminFleet: {
      Title: 'Fleet',
      MenuTitle: 'Manage Fleet',
      List: {
        NbAdminFleet: 'No fleet | {n} fleet | {n} fleets',
        AddTooltip: 'Add a fleet',
        ReachAdminFleetTooltip: 'Edit this fleet',
        FilterOngoing: 'Ongoing fleet',
      },
      Form: {
        Modify: 'Edit fleet',
        New: 'New fleet',
        Libelle: 'Alias',
        Ongoing: 'Ongoing',
        Missions: 'Missions',
        Company: 'Company',
      },
      Config: {},
    },
    MissionPlanTemplate: {
      Title: 'Mission Plan Template',
      MenuTitle: 'Manage Mission Plan Template',
      List: {
        NbMissionPlanTemplate: 'No mission plan template | {n} mission plan template | {n} mission plan templates',
        AddTooltip: 'Add a mission plan template',
        ReachMissionPlanTemplateTooltip: 'Edit this mission plan template',
      },
      Form: {
        Modify: 'Edit mission plan template',
        New: 'New  mission plan template',
        Libelle: 'Alias',
        Company: 'Company',
        StepList: 'Steps',
        WayPoint: 'WayPoint',
        Profiles: 'Profiles',
        ProfilesSci: 'Profiles Sci',
        Payload: 'Payload',
        Sensor: 'Sensor',
        Profil: 'Profile nav',
        ProfilSci: 'Profile sci',
        RVal: 'rVal (km)',
        RValTooltip: 'WayPoint validation distance - validation radius',
        TVal: 'tVal (min)',
        TValTooltip: 'Time (min) to remain on the Point once the distance is validated - 0 by default',
        LastAction: 'Action to execute at the end',
        Label: 'label',
        Lat: 'lat',
        Lng: 'lng',
        CancelTooltip: 'Cancel',
        ValidTooltip: 'Valid',
        Cancel: 'Cancel',
        Valid: 'Valid',
        Edit: 'Edit',
        AddStepToPoint: 'Add a step to this point',
        AddStep: 'Add a step',
        DeleteWaypoint: 'Delete waypoint',
        AddGlobalWaypoint: 'Add a global waypoint',
        AddWaypoint: 'Add a waypoint',
        NavigationProfil: 'Navigation profile',
        ScienceProfil: 'Science profile',
        LabelTooltip: 'A non-mandatory label',
        Bd: 'bd',
        BdTooltip: 'Ballast value applied on the the way down ml',
        Bu: 'bu',
        BuTooltip: 'Value of ballast applied on the way up in ml',
        Pd: 'pd',
        PdTooltip: 'Pitch value applied on the the way down in mm',
        Pu: 'pu',
        PuTooltip: 'Pitch value applied on the the way up in mm',
        Sr: 'sr',
        SrTooltip: 'The frequency of surfacing in number of yo',
        Zb: 'zb',
        ZbTooltip: 'Bottom rollover value in m',
        Zt: 'zt',
        ZtTooltip: 'Top rollover value in m',
        Zs: 'zs',
        ZsTooltip: 'Immersion value for generating a surface in m',
        Alt: 'alt',
        AltTooltip: 'Minimum altitude value to cause a rollover',
        GlobalWaypoints: 'Global Waypoints',
        SelectTooltip: 'Select',
        VirtualMooring: 'Virtual mooring',
        ConfirmDeleteStepMessage: 'Do you really want to delete this step?',
        ConfirmDeleteWaypointMessage: 'Do you really want to delete this waypoint?',
        ConfirmDeleteProfilMessage: 'Do you really want to delete this profile?',
        ConfirmDeleteProfilSciMessage: 'Do you really want to delete this science profile?',
        ConfirmDeleteSensorMessage: 'Do you really want to delete this sensor?',
        NewProfil: 'New navigation profile',
        NewProfilSci: 'New science profile',
        CurrentStep: 'Current step',
        SensorEnable: 'Enable sensor',
        SensorEnablePhases: 'Sensor enable phases',
        SensorEnableAtDesc: 'Enable on going down',
        SensorEnableAtAsc: 'Enable on going up',
        SensorEnableAtOther: 'Enable on other phases',
        SensorFrequency: 'Acquisition period (s)',
        SensorDisabled: 'disabled',
        Sensors: 'Sensors',
      },
    },
    PositionRemarquable: {
      Title: 'Global Waypoint',
      MenuTitle: 'Manage Global Waypoint',
      List: {
        NbPositionRemarquable: 'No global waypoint | {n} global waypoint | {n} global waypoints',
        AddTooltip: 'Add a global waypoint',
        ReachPositionRemarquableTooltip: 'Edit this global waypoint',
      },
      Form: {
        Modify: 'Edit global waypoint',
        New: 'New global waypoint',
        Libelle: 'Libelle',
        Lat: 'Latitude',
        Lng: 'Longitude',
        Company: 'Company',
      },
    },
    MapLayer: {
      Title: 'Map Layer',
      MenuTitle: 'Manage Map Layer',
      List: {
        NbMapLayer: 'No map layer | {n} map layer | {n} map layers',
        AddTooltip: 'Add a map layer',
        ReachMapLayerTooltip: 'Edit this map layer',
      },
      Form: {
        Modify: 'Edit map layer',
        New: 'New map layer',
        Libelle: 'Libelle',
        Company: 'Company',
        Group: 'Layer group name',
        Scope: 'Layer scope',
        Mission: 'Mission',
        MissionGlobal: 'Smart planning',
        Config: 'Configuration',
        ReadKml: 'Read Kml file',
        Data: 'Data KML',
        Type: 'Type',
        ServiceUrl: 'Service url',
        Layer: 'Layer',
        NoConfig: 'No layer service configured',
        TestOptions: 'Test the layer options',
        WizardTitle: 'Configure Layer Service',
        LayerSelection: 'Layer selection',
        Options: 'Options',
        LayerType: 'Layer service type',
        Cancel: 'Cancel',
        Continue: 'Continue',
        ServiceWMS: 'Service WMS',
        LayerInformation: 'Layer information',
        LayerTitle: 'Title',
        LayerName: 'Name',
        LayerAbstract: 'Abstract',
        LayerService: 'Service',
        SelectStyles: 'Choose applicable styles',
        ScaleValue: 'Configure default scale values',
        ScaleUnit: 'Scale unit',
        ScaleHint: 'You can find the unit on the scale image (i button)',
        Offset: 'Offset to add for conversion',
        OffsetHint: 'Useful for the conversion K => °C for example',
        ScaleMin: 'Scale min value',
        ScaleMax: 'Scale max value',
        DefaultStyle: 'Default styling',
        EnableDim: 'Enable dimension configuration',
        DimName: 'Name',
        StartDate: 'Authorized service start date',
        AvailableDay: 'Available in day',
        Step: 'Step',
        SelectAll: 'Select all',
        UnselectAll: 'Unselect all',
        ServicePopup: 'Service Info popup',
        Credit: 'Credit',
        UrlInfo: 'Url Info',
        UrlInfoHint: 'Information URL on the service or its provider',
        ValidConfig: 'Valid Config',
        DefaultValue: 'Default value',
      },
    },
    UploadFile: {
      Title: 'Upload mission files',
      MenuTitle: 'Upload mission files',
    },
    CmdCompletion: {
      Title: 'Command completion',
      FullTitle: 'Managing the glider command completion list',
      MenuTitle: 'Manage command completion',
      List: 'Command list (one per line)',
      Loading: 'Loading command list completion',
      Loaded: 'Command list completion loaded',
      Saving: 'Saving command list completion',
      Saved: 'Command list completion saved',
      ReadCmdFile: 'READ CMD FILE (.TXT)',
    },
    Nmea: {
      Title: 'Managing Nmea Display',
      FullTitle: 'Managing Nmea field to display',
      MenuTitle: 'Manage Nmea Display',
      ConfigSample: '[NMEA_NAME]:[Col1Variable]|[Col1Libelle]|[Col2Variable]|[Col2Libelle]|[Unit2]',
      Config: 'Nmea config',
      Loading: 'Loading nmea display config',
      Loaded: 'Nmea display config loaded',
      Error: 'Nmea display config error',
      Saving: 'Saving nmea display config',
      Saved: 'Nmea display config saved',
      HideNmeaTooltip: 'Hide nmea from misson panel',
      ShowNmeaTooltip: 'Show nmea on misson panel',
      HideConfigTooltip: 'Hide config nmea fields',
      ShowConfigTooltip: 'Show config nmea fields',
      AvailableField: 'Available fields (Not displayed on mission panel)',
      DisplayField: 'Field diplayed on mission panel',
      AvailableNmea: 'Available nmea (Not displayed on mission panel)',
      NmeaPreLoaded: 'Nmea visible on detail',
      NmeaLazyLoaded: 'Nmea visible on demand',
      LibelleFr: 'Label [Fr]',
      LibelleEn: 'Label [En]',
      Unit: 'Unit',
      CanBePlot: 'Can be plot',
      OnMainPlot: 'Show on main nmea plots',
      OffsetYoForPlot: 'Surfacing Yos offset for graphs',
      PlotGroup: 'Grouping plot key',
    },
    MsgAccueil: {
      Title: 'Message login',
      FullTitle: 'Managing the login information message',
      MenuTitle: 'Manage message login',
      Loading: 'Loading login message',
      Loaded: 'Login message loaded',
      Saving: 'Saving login message',
      Saved: 'Login message saved',
      Text: 'Login infos message',
      Planification: 'Planning',
      UsePlanif: 'Enable planning',
      StartShow: 'Display start (UTC) :',
      EndShow: 'End of display (UTC) :',
    },
    Image: {
      Title: 'Home image',
      FullTitle: 'Managing home image',
      MenuTitle: 'Manage Home Image',
      AddImage: 'Add images',
    },
    PwdPolicy: {
      Title: 'Password policy',
      FullTitle: 'Managing password policy',
      MenuTitle: 'Manage password policy',
      Loading: 'Loading the password policy',
      Loaded: 'Password policy loaded',
      MinLength: 'Minimum size in characters',
      MinNumber: 'Minimum number of digits',
      MinSpecial: 'Minimum number of special characters',
      MinUpperCase: 'Minimum number of uppercase characters',
      MinLowerCase: 'Minimum number of lowercase characters',
      HistoryRetention: 'Number of passwords stored for reuse',
      ValidityPeriod: 'Maximum period in days before password change',
      ExpirePeriod: 'Number of days before expiration to request password change',
      DenyAccessIfPassHasExpired: 'Deny access if password has expired',
      DenyAccessIfPassHasNoDate: 'Deny access if password change date is unknown',
      DisablePasswordPolicy: 'Disable password security policy',
    },
  },
}
